import React from 'react';
import { cn } from '@/lib/utils';
import { motion, useReducedMotion } from 'framer-motion';
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  fullWidthMobile?: boolean;
  href?: string;
  pulse?: boolean;
  size?: 'default' | 'large';
};
const CHECKOUT_URL = 'https://le-protocole-clinique.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  fullWidthMobile = true,
  href = CHECKOUT_URL,
  pulse = false,
  size = 'default'
}: CTAButtonProps) {
  const shouldReduceMotion = useReducedMotion();
  const sizeClasses = size === 'large' ? 'px-10 py-6 text-lg sm:px-12 sm:text-xl' : 'px-8 py-5 text-base sm:text-lg';
  return <motion.a href={href} animate={pulse && !shouldReduceMotion ? {
    scale: [1, 1.04, 1]
  } : undefined} transition={pulse && !shouldReduceMotion ? {
    duration: 2.5,
    ease: 'easeInOut',
    repeat: Infinity
  } : undefined} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.99
  }} onClick={event => {
    if (!href.startsWith('#')) return;
    const target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    window.history.pushState(null, '', href);
    const destination = target.getBoundingClientRect().top + window.scrollY - 16;
    if (shouldReduceMotion) {
      window.scrollTo(0, destination);
      return;
    }
    const start = window.scrollY;
    const distance = destination - start;
    const duration = 1400;
    const startTime = performance.now();
    const scrollStep = (currentTime: number) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 4);
      window.scrollTo(0, start + distance * easedProgress);
      if (progress < 1) window.requestAnimationFrame(scrollStep);
    };
    window.requestAnimationFrame(scrollStep);
  }} className={cn(['inline-flex items-center justify-center gap-2 rounded-full bg-grass font-extrabold uppercase tracking-wide text-black shadow-lg shadow-grass/20 transition-colors duration-200 hover:bg-grass-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-black', sizeClasses, fullWidthMobile ? 'w-full sm:w-auto' : '', className].join(' '), 'pt-[10px] pb-[10px] pl-[15px] pr-[15px]')} data-id="element-63">
      {children}
    </motion.a>;
}